<template>
  <div id="app">
    <div style="display: flex;">
      <img style="width: 100%;height: 100px;   padding: 0; margin: 0;" src="@/assets/images/top-new.jpg" alt="">
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
